import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import "./StudyDetail.css";

const StudyDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [study, setStudy] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/patients/studies/${id}/`, {
        headers: { Authorization: `Token ${token}` },
      })
      .then((res) => {
        setStudy(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Error fetching Study detail");
        setLoading(false);
      });
  }, [id, token]);

  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete this study?")) {
      axios
        .delete(`${process.env.REACT_APP_BACKEND_URL}/patients/studies/${id}/delete/`, {
          headers: { Authorization: `Token ${token}` },
        })
        .then(() => {
          navigate("/studies");
        })
        .catch((err) => {
          alert("Error deleting study");
        });
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="error-message">{error}</p>;
  if (!study) return <p>No Study found.</p>;

  return (
    <div className="study-detail-container">
      <h3>Study Detail</h3>
      <p>
        <strong>ID:</strong> {study.id}
      </p>
      <p>
        <strong>Study Instance ID:</strong> {study.study_instance_id}
      </p>
      <p>
        <strong>Patient:</strong> {study.patient}
      </p>
      <p>
        <strong>Number of XA DICOM entries for study:</strong>
        <Link to={`/dicoms?patient=${study.patient}&study=${study.id}`}>
          {study.dicom_count}
        </Link>
      </p>
      <p>
        <strong>Uploader:</strong> {study.uploader}
      </p>
      <p>
        <strong>Creation Time:</strong>{" "}
        {new Date(study.creation_time).toLocaleString()}
      </p>
      <p>
        <strong>Updated Time:</strong>{" "}
        {new Date(study.updated_time).toLocaleString()}
      </p>
      <div className="patient-detail-actions">
        <Link to={`/studies/${id}/edit`}>
          <button>Edit</button>
        </Link>
        <Link to={`/patients/${study.patient}`}>
          <button>View Patient</button>
        </Link>
        <Link to={`/dicoms?patient=${study.patient}&study=${id}`}>
          <button>View DICOMs</button>
        </Link>
        <button onClick={handleDelete}>Delete</button>
      </div>
    </div>
  );
};

export default StudyDetail;
